import { useQuery } from '@tanstack/react-query'
import { motion } from 'framer-motion'
import { BarChart3 } from 'lucide-react'
import { apiRequest } from '@/lib/utils'

export default function AnalyticsHeader() {
  const { data: analytics, isLoading } = useQuery({
    queryKey: ['analytics', 'stats'],
    queryFn: () => apiRequest('/analytics/stats'),
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 10000 // Consider data stale after 10 seconds
  })

  if (isLoading) {
    return (
      <motion.div 
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4"
      >
        <div className="container mx-auto flex items-center justify-center">
          <div className="flex items-center space-x-2">
            <BarChart3 className="h-5 w-5 animate-pulse" />
            <span className="text-sm font-medium">Loading analytics...</span>
          </div>
        </div>
      </motion.div>
    )
  }

  const documentsCount = analytics?.documentsAnalyzed || 0

  return (
    <motion.div 
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4"
    >
      <div className="container mx-auto flex items-center justify-center">
        <div className="flex items-center space-x-2" data-testid="analytics-counter">
          <BarChart3 className="h-5 w-5" />
          <span className="text-sm font-medium">
            📊 {documentsCount.toLocaleString()} Lease Documents Analyzed
          </span>
        </div>
      </div>
    </motion.div>
  )
}